import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import './lib/i18n'
import { initEndorselyReferralCapture } from './lib/endorsely'
import { PostHogProvider } from './lib/posthog'
import { registerServiceWorker } from './lib/serviceWorkerRegistration'

initEndorselyReferralCapture();
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <PostHogProvider>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </PostHogProvider>
);
